<template>
  <div
    class="a-radio"
    :class="{
      'is-active': isChecked,
      'is-disabled': disabled,
      '-invalid' : fieldHasError
    }"
  >
    <label class="a-radio__container">
      <input
        :id="id || false"
        type="radio"
        :name="name"
        :value="value"
        :checked="isChecked"
        :disabled="disabled"
        class="a-radio__input"
        v-on="listeners"
      >
      <!-- @slot Custom checkmark markup (bind 'isChecked' boolean, 'disabled' boolean -->
      <slot name="checkmark" v-bind="{ isChecked, disabled }">
        <div
          class="a-radio__checkmark"
          :class="{ '-is-active': isChecked }"
        />
      </slot>
      <div class="a-radio__content">
        <!-- @slot Custom label markup (bind 'label' string, 'isChecked' boolean, 'disabled' boolean -->
        <slot name="label" v-bind="{ label, isChecked, disabled }">
          <div v-if="label" class="a-radio__label">{{ label }}</div>
        </slot>
      </div>
    </label>
  </div>
</template>
<script>
export default {
  name: 'BaseRadio',
  model: {
    prop: 'selected',
    event: 'input'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectedValue: {
      type: String,
      default: ''
    },
    selected: {
      type: String,
      default: ''
    }
  },
  computed: {
    listeners (){
      return {
        ...this.$listeners,
        input: () => this.$emit('input', this.value),
      }
    },
    isChecked () {
      return this.value === (this.selected ? this.selected : this.selectedValue);
    },
    fieldHasError () {
      return typeof (this.errors) !== 'undefined' && this.errors.items.find(x => x.field === this.name) != null;
    },
  },
  methods: {
    inputHandler () {
      this.$emit('input', this.value);
    }
  }
};
</script>
